__turbopack_context__.v({
  "barArea": "styles-module__Ck9-KG__barArea",
  "navButton": "styles-module__Ck9-KG__navButton",
  "navButtonIcon": "styles-module__Ck9-KG__navButtonIcon",
  "navButtonPlaceholder": "styles-module__Ck9-KG__navButtonPlaceholder",
  "navigationWrapper": "styles-module__Ck9-KG__navigationWrapper",
  "progressionBarText": "styles-module__Ck9-KG__progressionBarText",
  "wrapper": "styles-module__Ck9-KG__wrapper",
});
